(function(){
    var images = document.querySelectorAll(".product__product-image-container img");
    var thumbnails = document.querySelectorAll(".product__thumbnails-list li");

    function thumbnail_clicked(e) {
        var image_index = e.currentTarget.id.split('_')[1];
        for (var i = 0; i < images.length; i++) {
            images[i].style['opacity'] = '0';
        }
        document.getElementById("productimage_" + image_index).style['opacity'] = '1';
    }

    for (var i = 0; i < thumbnails.length; i++) {
        thumbnails[i].addEventListener('click', thumbnail_clicked);
    }
})();
